let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import Confetti from 'growth-onboarding-confetti/Confetti';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIFlex from 'UIComponents/layout/UIFlex';
import OnboardingTourButtons from '../OnboardingTourButtons';

// Hide the banner from modals and show it only after the user action on the modal CTA.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HandholdingBannerGlobalStyle = createGlobalStyle(_t || (_t = _`
.uiFullScreenBackground #onboarding-tours-banner-frame {
  filter: blur(5px);
  z-index: auto !important
  }
  `));
const OnboardingTourImageModal = ({
  step: {
    title,
    text,
    buttons,
    image,
    modal
  },
  onCloseComplete,
  onOpenStart,
  rootNode,
  'data-test-step-index': dataTestStepIndex
}) => {
  const modalProps = modal !== undefined && typeof modal !== 'boolean' ? modal : {};
  const {
    showConfetti
  } = modalProps;
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-step-index": dataTestStepIndex,
    onCloseComplete: onCloseComplete,
    onOpenStart: onOpenStart,
    rootNode: rootNode,
    use: "conversational",
    width: 788,
    children: [showConfetti && /*#__PURE__*/_jsx(Confetti, {
      widthPercentage: 300
    }), /*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h3",
        children: title
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockStart: "600",
        typography: "body-200",
        children: text
      }), image && /*#__PURE__*/_jsx(UIFlex, {
        justify: "center",
        children: /*#__PURE__*/_jsx(Image, {
          alt: image.alt,
          inlineSize: image.width ? `${image.width}px` : undefined,
          marginBlockStart: "600",
          src: image.src
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      className: "p-left-0 p-right-0",
      children: /*#__PURE__*/_jsx(OnboardingTourButtons, {
        buttons: buttons || []
      })
    }), /*#__PURE__*/_jsx(HandholdingBannerGlobalStyle, {})]
  });
};
export default OnboardingTourImageModal;